<template>
  <div class="big-box" id="home">
    <!-- section home paling atas -->
    <div class="container max-width row" id="home-section">
      <div class="container column" id="left-section">
        <div class="container column" id="box-logo">
          <img
            src="../assets/homepage-doodle.png"
            alt="Tagline PO Fasilkom"
            id="logo-tagline"
          />
        </div>
        <div class="container column" id="left-text-box">
          <span class="title">Persekutuan Oikumene</span>
          <span class="sub-title"
            >Fakultas Ilmu Komputer, Universitas Indonesia</span
          >
        </div>
      </div>
      <div class="container column" id="right-section">
        <RenunganLanding />
      </div>
    </div>
    <!-- section about PO -->
    <div class="container max-width column" id="about">
      <span class="title" id="about-title">Tentang PO Fasilkom UI</span>
      <div class="container row" id="box-visi-misi">
        <div class="container column" id="about-left-section">
          <div class="container about-sub-title">
            <span class="sub-title">
              VISI
            </span>
          </div>
          <div class="container about-body">
            <span class="body">
              "Menghasilkan pribadi yang menjadikan Tuhan sebagai pusat
              hidupnya, menikmati persekutuan dalam Tuhan, dan mencerminkan
              pribadi Kristus dalam kehidupannya"
            </span>
          </div>
        </div>
        <div class="container column" id="about-right-section">
          <div class="container about-sub-title misi-content" id="misi">
            <span class="sub-title">
              MISI
            </span>
          </div>
          <div class="container column about-body" id="poin-misi">
            <ol>
              <li class="body">
                Jemaat membaca, memahami, dan melaksanakan Firman
              </li>
              <li class="body">
                Jemaat memiliki hubungan yang intim dengan Tuhan
              </li>
              <li class="body">
                Melaksanakan pemuridan melalui 4P (penginjilan, pembinaan,
                pelipatgandaan, pengutusan)
              </li>
              <li class="body">
                Jemaat menikmati persekututan di dalam PO Fasilkom UI
              </li>
              <li class="body">
                Mendorong jemaat PO Fasilkom UI untuk lebih berdampak secara
                nyata di lingkungan sekitarnya, terkhusus di Fasilkom UI
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <!-- section Nilai PO Fasilkom -->
    <div class="container max-width column" id="nilai-section">
      <span class="title container" id="nilai-title">Nilai PO Fasilkom UI</span>
      <div class="container max-width row" id="box-nilai">
        <div class="container column item-nilai">
          <img
            src="../assets/Alkitabiah-logo.png"
            alt="Logo Alkitabiah"
            class="img-nilai"
          />
          <span class="sub-title">Alkitabiah</span>
        </div>
        <div class="container column item-nilai">
          <img
            src="../assets/Interdenominasi-logo.png"
            alt="Logo Interdenominasi"
            class="img-nilai"
          />
          <span class="sub-title">Interdenominasi</span>
        </div>
        <div class="container column item-nilai">
          <img
            src="../assets/Kekeluargaan-logo.png"
            alt="Logo Kekeluargaan"
            class="img-nilai"
          />
          <span class="sub-title">Kekeluargaan</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RenunganLanding from "@/components/RenunganLanding.vue";
export default {
  name: "Home",
  components: {
    RenunganLanding
  },
  mounted() {
    var section = this.$router.currentRoute.hash.replace("#", "");
    if (section) {
      this.$nextTick(() => {
        window.document.getElementById(section).scrollIntoView();
      });
    }
  }
};
</script>

<style scoped>
#home {
  min-height: 100vh;
}

#home-section {
  background-color: #f4f2f5;
  margin-top: 7vh;
  padding: 16vh 0 7vh;
}

#left-section {
  width: 60%;
  color: black;
  align-items: flex-start;
  text-align: left;
  padding-bottom: 2em;
}

#right-section {
  width: 40%;
  min-height: 72vh;
  background-color: #28587c;
  color: #fdfdfd;
  border-radius: 5px;
  margin-right: 25px;
}

#box-logo {
  width: 90%;
  margin-bottom: 5px;
}

#left-text-box {
  align-items: flex-start;
  margin: 20px 0px 0px 40px;
}

#logo-tagline {
  width: 32vw;
  height: auto;
}

#about {
  background-color: #d6e5ed;
  color: black;
  justify-content: flex-start;
  text-align: center;
  padding: 6em 0 5em;
  height: 100%;
}

#about-title {
  margin-top: 20px;
}

#box-visi-misi {
  width: 90%;
  margin-top: 2vh;
  padding: 5vh 0;
}

.about-sub-title {
  height: 20%;
  width: 90%;
  margin: 1em 0;
}

.about-body {
  height: 80%;
  width: 80%;
  align-items: flex-start;
}

.misi-content {
  text-align: left;
}

#poin-misi {
  width: 90%;
  justify-content: flex-start;
}

ol {
  margin: 0;
}

.left-content {
  width: 10%;
}

.nomor {
  height: 100%;
  text-align: center;
}

.right-content {
  width: 90%;
}

#about-left-section {
  width: 30%;
  background-color: rgb(255, 107, 0, 0.63);
  border-radius: 30px;
  padding: 1em 0 4em 0;
}

#about-right-section {
  width: 70%;
  background-color: rgb(255, 202, 100, 0.81);
  border-radius: 30px;
  margin-left: 4vw;
  text-align: left;
  padding: 1em 0 3em 0;
}

#nilai-section {
  background-color: #f4f2f5;
  color: black;
  text-align: center;
  padding: 10vh 0 18vh;
}

#nilai-title {
  padding: 0 0 5vh;
}

#box-nilai {
  width: 95%;
  align-items: flex-start;
}

.item-nilai {
  width: 30%;
  margin: 0 1vw;
}

.img-nilai {
  width: 28vw;
  height: auto;
  margin-bottom: 1vh;
}

@media screen and (max-width: 768px) {
  #home-section {
    flex-direction: column;
    margin-top: 8vh;
    padding: 10vh 0 0;
  }

  #left-section {
    width: 100%;
  }

  #right-section {
    width: 100%;
    min-height: 25vh;
    border-radius: 0px;
    margin-right: 0px;
  }

  #box-logo {
    margin-bottom: 0px;
    width: 100%;
  }

  #logo-tagline {
    width: 90vw;
    height: auto;
  }

  #left-text-box {
    align-items: flex-start;
    margin: 15px 0px 0px 10px;
  }
  #about {
    padding: 4em 0 2em;
  }

  #box-visi-misi {
    flex-direction: column;
  }

  .misi-content {
    justify-content: center;
  }

  #about-left-section {
    width: 90%;
  }

  #about-right-section {
    width: 90%;
    margin-left: 0;
    margin-top: 3vh;
  }

  .about-title {
    margin: 2vh;
  }

  ol {
    padding-left: 5vw;
  }

  #nilai-section {
    padding-top: 8vh;
  }

  #box-nilai {
    width: 95%;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

  .item-nilai {
    width: 90%;
    margin: 2vh 0;
  }

  .img-nilai {
    max-width: 400px;
    width: 75vw;
    height: auto;
    margin-bottom: 1vh;
  }
}

@media screen and (max-width: 375px) {
  #home {
    margin-top: 9vh;
  }

  #home-section {
    padding-top: 8vh;
  }

  #logo-tagline {
    width: 75vw;
    height: auto;
  }

  /* #about {
    padding-top: 15vh;
  } */

  #box-nilai {
    width: 95%;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

  .item-nilai {
    width: 90%;
    margin: 3vh 0;
  }

  .img-nilai {
    width: 74vw;
    height: auto;
    margin: 2vh 0;
  }
}
@media screen and (max-width: 320px) {
  #home-section {
    margin-top: 12vh;
    padding: 5vh 0 0;
  }
}
</style>
